export enum ExportDataSupportedEntities {
  specification = 'specification',
  specificationCategory = 'specificationCategory',
}
